import type { PropsWithChildren } from 'react';

interface ConditionProps extends PropsWithChildren {
  visible: boolean;
}

export function Condition({ visible, children }: ConditionProps) {
  return visible ? children : null;
}

Condition.displayName = 'Condition';
